import ApiExtension from './api-extension'

export default class Farm extends ApiExtension {
  createFarm(farmName) {
    return this.fetch(
      'farms',
      {},
      {
        method: 'POST',
        body: JSON.stringify({ name: farmName }),
      }
    )
  }

  updateFarm(farmId, farmName) {
    return this.fetch(
      'farm',
      { id: farmId },
      {
        method: 'PUT',
        body: JSON.stringify({ name: farmName }),
      }
    )
  }

  deleteFarm(farmId) {
    return this.fetch(
      'farm',
      { id: farmId },
      {
        method: 'DELETE',
      }
    )
  }

  createShare(farmId, userEmail) {
    return this.apiBase.fetch(
      'share_farm',
      { id: farmId },
      {
        method: 'POST',
        body: JSON.stringify({ shared_with: userEmail }),
      }
    )
  }

  deleteShare(shareId) {
    return this.apiBase.fetch(
      'delete_share',
      {},
      {
        method: 'DELETE',
        body: JSON.stringify({ share_id: shareId }),
      }
    )
  }
}
